import { StyledAnchor, StyledButton } from "./styles";
import { ButtonProps } from "../types";

const isExternal = (href: string) => /^https?:\/\//i.test(href);

/**
 * One button, three looks.
 *
 * Renders an <a> when given `href` so links stay links — right-click, open in
 * new tab and middle-click all keep working, which a div-with-onClick breaks.
 */
export const Button = ({
  children,
  variant = "primary",
  size = "md",
  href,
  onClick,
  fixedWidth,
  block,
  disabled,
  type = "button",
  ariaLabel,
  className,
}: ButtonProps) => {
  const shared = {
    $variant: variant,
    $size: size,
    $fixedWidth: fixedWidth,
    $block: block,
    className,
    "aria-label": ariaLabel,
  };

  if (href && !disabled) {
    const external = isExternal(href);
    return (
      <StyledAnchor
        {...shared}
        href={href}
        onClick={onClick}
        target={external ? "_blank" : undefined}
        rel={external ? "noopener noreferrer" : undefined}
      >
        {children}
      </StyledAnchor>
    );
  }

  return (
    <StyledButton {...shared} type={type} onClick={onClick} disabled={disabled}>
      {children}
    </StyledButton>
  );
};

export default Button;
